import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private _http: HttpClient) {}

  checkAccount(email): Observable<any> {
    return this._http.post(`${baseUrl}/users/forgot-password`, { email });
  }
}
